import { AccountDialog } from './AccountDialog';
import { useAccountDialog } from './AccountDialog/useAccountDialog';
import { BondingTradeDialog } from './BondingTradeDialog';
import { useBondingTradeDialog } from './BondingTradeDialog/useBondingTradeDialog';
import { DevUtils } from './DevUtils';
import { GraduateModal } from './GraduateModal/GraduateModal';
import { useGraduateModal } from './GraduateModal/useGraduateModal';
import { H2SwapDialog } from './H2SwapDialog';
import { useH2SwapDialog } from './H2SwapDialog/useH2SwapDialog';
import { LazyComponent } from './LazyComponent';
import { ProfileDrawer } from './ProfileDrawer';
import { useProfileDrawer } from './ProfileDrawer/useProfileDrawer';
import { SetUsernameModal } from './SetUsernameModal';
import { useSetUsernameModal } from './SetUsernameModal/useSetUsernameModal';
import { Toaster } from './Toaster';
import { TokenSelectDialog } from './TokenSelectDialog';
import { useTokenSelectDialog } from './TokenSelectDialog/useTokenSelectDialog';
import { useWalletModal, WalletModal } from './Wallet';

export const GlobalComponents = () => {
  const isOpenWalletModalOpen = useWalletModal((s) => s.isOpen);
  const isBondingTradeDialogOpen = useBondingTradeDialog((s) => s.isOpen);
  const isTokenSelectDialogOpen = useTokenSelectDialog((s) => s.isOpen);
  const isSetUsernameModalOpen = useSetUsernameModal((s) => s.isOpen);
  const isAccountDialogOpen = useAccountDialog((s) => s.isOpen);
  const isGraduateModalOpen = useGraduateModal((s) => s.isOpen);
  const isH2SwapDialogOpen = useH2SwapDialog((s) => s.isOpen);
  const isProfileDrawerOpen = useProfileDrawer((s) => s.isOpen);

  return (
    <>
      <DevUtils />
      <Toaster />
      <LazyComponent isOpen={isOpenWalletModalOpen}>
        <WalletModal />
      </LazyComponent>
      <LazyComponent isOpen={isBondingTradeDialogOpen}>
        <BondingTradeDialog />
      </LazyComponent>
      <LazyComponent isOpen={isTokenSelectDialogOpen}>
        <TokenSelectDialog />
      </LazyComponent>
      <LazyComponent isOpen={isSetUsernameModalOpen}>
        <SetUsernameModal />
      </LazyComponent>
      <LazyComponent isOpen={isAccountDialogOpen}>
        <AccountDialog />
      </LazyComponent>
      <LazyComponent isOpen={isGraduateModalOpen}>
        <GraduateModal />
      </LazyComponent>
      <LazyComponent isOpen={isH2SwapDialogOpen}>
        <H2SwapDialog />
      </LazyComponent>
      <LazyComponent isOpen={isProfileDrawerOpen}>
        <ProfileDrawer />
      </LazyComponent>
    </>
  );
};
